import { render, staticRenderFns } from "./landing.vue?vue&type=template&id=c201e402&scoped=true"
import script from "./landing.vue?vue&type=script&lang=js"
export * from "./landing.vue?vue&type=script&lang=js"
import style0 from "./landing.vue?vue&type=style&index=0&id=c201e402&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c201e402",
  null
  
)

export default component.exports